import React, { useState } from 'react';
import { View, StyleSheet, Image } from 'react-native';
import Images from '../../constants/Images';
import { Color, CommonProperties, FontSize } from '../../styles';
import AnimatedSwitch from '../AnimatedSwitch';
import BaseText from '../BaseText';
import TabBar from '../SegmentedControl/TabBar';

const RebookModal = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  return (
    <View style={styles.body}>
      <BaseText style={styles.textHeading}>Where Can I Find My Confirmation Code?</BaseText>
      <BaseText style={styles.rebookText}>
        Your Confirmation Code is 6 characters long and might be a combination of letters and
        numbers.
      </BaseText>
      <View style={styles.switchWrap}>
        <AnimatedSwitch onChangeType={setSelectedTab} labelRight={'App'} labelLeft={'Agent '} />
      </View>
      {selectedTab ? (
        <View style={styles.agentSection}>
          <BaseText style={styles.agentText}>Below is an example from FlyFrontier's App.</BaseText>
          <Image style={styles.image} source={require('../../assets/images/frontier.png')} />
        </View>
      ) : (
        <View style={styles.agentSection}>
          <BaseText style={styles.agentText}>Below is an example on a paper print out.</BaseText>
          <Image style={styles.image} source={require('../../assets/images/agent.png')} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flex: 1,
    backgroundColor: 'white',
  },
  textHeading: {
    fontSize: FontSize.h1,
    fontWeight: '600',
    textAlign: 'center',
    marginHorizontal: '10%',
    marginVertical: '10%',
  },
  rebookText: {
    fontSize: FontSize.h2,
    textAlign: 'center',
    marginHorizontal: '10%',
  },
  agentText: {
    color: Color.grayText,
    textAlign: 'center',
  },
  agentSection: {
    marginHorizontal: '10%',
  },
  switchWrap: {
    alignItems: 'center',
    ...CommonProperties.my5,
  },
  image: {
    ...CommonProperties.my5,
    width: 300,
    height: 100,
  },
});

export default RebookModal;
